// Mock data and defaults for Zamzam Capital - Position Size Calculator

export const DEFAULT_VALUES = {
  portfolioSize: 100000,
  riskPercent: 2,
  entryPrice: 1500,
  stopLossPrice: 1450,
  stopLossPercent: 3.33,
};

export const BENEFITS = [
  {
    n: 1,
    title: 'Better Risk Management',
    body:
      'A position size calculator will enhance your risk management by calculating how many shares or contracts you should trade, given your risk tolerance and account size. This ensures any potential losses will be limited to a predetermined percentage of your capital. The purpose of using a position size calculator is to preserve your trading account and maintain financial stability.',
  },
  {
    n: 2,
    title: 'Promotes Consistency and Discipline',
    body:
      'A position size calculator will force one to trade systematically. It removes emotional bias from decision-making since it leads to more consistent and disciplined trading practices. This consistency ensures that trading strategy analysis can be continuous over time and that the changes required are implemented.',
  },
  {
    n: 3,
    title: 'Optimises Capital Allocation',
    body:
      'This calculator assists you in allocating your trading capital effectively over many trades. You can do this by adjusting your position sizes based on the risk and potential return of each trade, maximising the overall performance of your portfolio while keeping a balanced risk profile.',
  },
  {
    n: 4,
    title: 'Simplifies Complex Calculations',
    body:
      'Manual position sizing takes time and is prone to potential mistakes. A position size calculator automates this process, providing both speed and accuracy. Such efficiency will enable you to focus more on the analysis of markets and strategy development.',
  },
  {
    n: 5,
    title: 'Increases Trading Flexibility',
    body:
      'Position size calculators are flexible, as traders can change inputs such as risk tolerance, stop-loss levels, and trade size to tailor the calculations according to their liking. This flexibility accommodates trading strategies that are both conservative and aggressive, enabling traders to manage risk and position themselves accordingly in a manner that fits their unique trading styles.',
  },
];

export const ABOUT_FEATURES = [
  {
    key: 'sebi',
    title: 'SEBI Registered',
    body: '100% compliant with regulatory standards allowing us to provide research on stocks to the public.',
  },
  {
    key: 'ethical',
    title: 'Ethical Investing',
    body: 'Committed to socially responsible investment practices that align with moral and ethical principles.',
  },
  {
    key: 'shariah',
    title: 'Shariah Compliant',
    body: 'All recommendations screened for Shariah compliance — no interest-based businesses or Non-Halal (Haram) sectors.',
  },
  {
    key: 'education',
    title: 'Investor Education',
    body: 'Empowering investors with knowledge, research tools, and educational resources for informed decisions.',
  },
];

export const SOCIAL_LINKS = [
  {
    name: 'WhatsApp',
    description: 'Chat with us directly',
    href: 'https://wa.me/8694010200',
    color: 'from-emerald-500 to-emerald-600',
  },
  {
    name: 'Telegram',
    description: 'Join our channel',
    href: 'https://t.me/zamzamcapital',
    color: 'from-sky-500 to-sky-600',
  },
  {
    name: 'Instagram',
    description: 'Follow our updates',
    href: 'https://instagram.com/zamzamcapital',
    color: 'from-pink-500 to-rose-500',
  },
  {
    name: 'YouTube',
    description: 'Grow your knowledge',
    href: 'https://www.youtube.com/@ZamzamCapital',
    color: 'from-red-500 to-red-600',
  },
];

export const RR_RATIOS = [1, 2, 3, 4];

export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_ca1d654e-8bfa-461f-bd68-9157967ae33f/artifacts/6994vhpz_download%20%2815%29.jpeg';
